import { purple } from "~/theme/palette/colors/colors"
import { lightColors } from "~/theme/palette/light/lightColors"

export const lightPalette = {
  ...lightColors,
  purple: {
    main: purple.main,
    16: purple["16"],
    15: purple["15"],
    14: purple["14"],
    13: purple["13"],
    12: purple["12"],
    11: purple["11"],
    10: purple["10"],
    9: purple["9"],
    8: purple["8"],
    7: purple["7"],
    6: purple["6"],
    5: purple["5"],
    4: purple["4"],
    3: purple["3"],
    2: purple["2"],
    1: purple["1"],
  },
}
